import { useState } from 'react';

import type { BookingEventDetail } from '@/types';

import { filterRegistrationsByWave, searchRegistrations } from './utils';

type UseRegistrationsFiltersParams = {
  event: BookingEventDetail | undefined;
  initialWaveId: number | null;
};

export const useRegistrationsFilters = (
  params: UseRegistrationsFiltersParams,
) => {
  const { event, initialWaveId } = params;

  const [selectedWaveId, setSelectedWaveId] = useState(initialWaveId);
  const [searchQuery, setSearchQuery] = useState('');

  const waveNames = new Map(
    (event?.waves ?? []).map((wave) => [wave.id, wave.name]),
  );
  const selectedWave = event?.waves.find((wave) => wave.id === selectedWaveId);

  const waveRegistrations = filterRegistrationsByWave(event, selectedWaveId);
  const registrations = searchRegistrations(waveRegistrations, searchQuery);

  const freeSpots = event?.split_into_waves
    ? (selectedWave?.free_spots ?? null)
    : (event?.free_spots ?? null);

  return {
    selectedWaveId,
    searchQuery,
    waveNames,
    registrations,
    isNothingFound: waveRegistrations.length > 0 && registrations.length === 0,
    isWaveUnpicked: !!event?.split_into_waves && !selectedWave,
    isAddDisabled: freeSpots === null || freeSpots <= 0,
    onWaveSelect: setSelectedWaveId,
    onSearchChange: setSearchQuery,
  };
};
